var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcMicrophone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "16px",
    viewBox: "0 0 10 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon Tiny") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.66666667,5.33333333 C2.09333333,5.33333333 0,3.23933333 0,0.666666667 C0,0.298666667 0.298666667,0 0.666666667,0 C1.03466667,0 1.33333333,0.298666667 1.33333333,0.666666667 C1.33333333,2.50466667 2.82866667,4 4.66666667,4 C6.50466667,4 8,2.50466667 8,0.666666667 C8,0.298666667 8.298,0 8.66666667,0 C9.03533333,0 9.33333333,0.298666667 9.33333333,0.666666667 C9.33333333,3.23933333 7.23933333,5.33333333 4.66666667,5.33333333 Z M8,7 L8,7 C8,6.45 7.55,6 7,6 L2.33333333,6 C1.78333333,6 1.33333333,6.45 1.33333333,7 L1.33333333,7 C1.33333333,7.55 1.78333333,8 2.33333333,8 L7,8 C7.55,8 8,7.55 8,7 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.66666667,10 L2.66666667,10 C1.2,10 0,8.8 0,7.33333333 L0,2.66666667 C0,1.2 1.2,0 2.66666667,0 L2.66666667,0 C4.13333333,0 5.33333333,1.2 5.33333333,2.66666667 L5.33333333,7.33333333 C5.33333333,8.8 4.13333333,10 2.66666667,10 Z",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MLP-deliverables",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Button-/-Text-with-Icon-Left-/-Large-/-Glass-/-Mouse-Copy-3",
    transform: "translate(-15.000000, -16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Button",
    transform: "translate(0.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Tiny",
    transform: "translate(12.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "//-Base",
    fillOpacity: 0,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("g", {
    id: "Glyph"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    opacity: 0.5,
    transform: "translate(3.333333, 7.333333)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u21B3-secondary-icon-tint",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    x: -3.33333333,
    y: -7.33333333,
    width: 16,
    height: 16
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(5.333333, 0.666667)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u21B3-icon-tint",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-4)",
    x: -5.33333333,
    y: -0.666666667,
    width: 16,
    height: 16
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMicrophone);
export default __webpack_public_path__ + "static/media/ic_microphone.e9dbbf3e5265c1d2619ae7040d610d7d.svg";
export { ForwardRef as ReactComponent };